import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import OpenWithIcon from '@mui/icons-material/OpenWith';
import { Box, Chip, Grid, Typography } from "@mui/material";
import moment from "moment";
import mapimg from "../../../../assets/images/map.png";
import dummyDriver from '../../../../assets/images/no-image.png';
import MountedForklift from '../../../../shared/common-utilities/Qualifications/MountedForklift.jsx';
import OpenRoof from '../../../../shared/common-utilities/Qualifications/OpenRoof.jsx';
import RoalerBed from '../../../../shared/common-utilities/Qualifications/RoalerBed.jsx';
import TailLift from '../../../../shared/common-utilities/Qualifications/TailLift.jsx';
import TemperatureHigh from '../../../../shared/common-utilities/Qualifications/TemperatureHigh.jsx';
import BoxTrailer from '../../../../shared/common-utilities/Trailer/BoxTrailer.jsx';
import TankTrailer from '../../../../shared/common-utilities/Trailer/TankTrailer.jsx';
import BoxedTruck12Ton2Axles from '../../../../shared/common-utilities/Truck/BoxedTruck12Ton2Axles.jsx';
import EuropeanTruck from '../../../../shared/common-utilities/Truck/EuropeanTruck.jsx';
import Advertising from '../../../../shared/common-utilities/utils/Advertising.jsx';
import TruckProgressIcon from '../../../../shared/common-utilities/utils/TruckProgressIcon.jsx';
import ChassisTrailer from './../../../../shared/common-utilities/Trailer/ChassisTrailer';
import FlatbedTruck from './../../../../shared/common-utilities/Truck/FlatbedTruck';

import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { drageItemsReducer } from '../../../../shared/ReduxStore/Reducers/dragReducer.jsx';
import { CommonConst as Consts } from '../../../../shared/common-utilities/enums/CommonConst.jsx';
import commonApiService from '../../../../shared/common-utilities/services/commonApiService';
import { ApiConst, getPartialTrip, planGroupResources } from '../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts';
import getSetDataService from '../../../../shared/common-utilities/services/getSetDataService';

import FiberManualRecordIcon from '@mui/icons-material/Circle';
import ControlCameraIcon from '@mui/icons-material/ControlCamera';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import ContainerIconWh from '../../../../shared/common-utilities/utils/ContainerIconWh.jsx';
import IcoRoute from '../../../../shared/common-utilities/utils/IcoRoute.js';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { process } from '@progress/kendo-data-query';
import dataStorageService from '../../../../shared/common-utilities/services/DataStorageService.jsx';


let apiService = commonApiService();
let service = getSetDataService();
let dataService = dataStorageService();

const ListItem = styled('li')(({ theme }) => ({
	margin: theme.spacing(0),
	position: 'relative',
	width:'33%'
}));

const CustomAgendaTooltip = (props) => {
	const { iconActive, currentEvent: initialCurrentEvent,noOfAction } = props;
	const dispatch = useDispatch();
	const startDateTime = useRef(null);
	const endDateTime = useRef(null);
	const tripDuration = useRef(0);
	const [customTooltipData, setCustomTooltipData] = useState([]);
	const [ptMovementData, setPtMovementData] = useState([]);
	const [currentEvent, setCurrentEvent] = useState(() => initialCurrentEvent);
	const tripStatusData = useRef([])
	useEffect(() => {
		if (initialCurrentEvent?.data?.length > 0) {
			const { start, end, actionCode, ...filteredData } = initialCurrentEvent.data[0];
			setCurrentEvent({ ...initialCurrentEvent, ...filteredData });
		} else {
			setCurrentEvent(initialCurrentEvent);
		}
	}, [initialCurrentEvent]);

	const getTooltipPersonalization = useCallback(() => {
		const event = currentEvent?.data?.length > 0 ? currentEvent.data[0] : currentEvent;

		if (!event) return;

		const obj = {
			tripNo: event.tripNo,
			partialTripNo: event.partialtripLineNo,
			routeNo: event.routeLineNo,
			driveAction: false,
			language: 0,
		};

		apiService
			.postWithId(planGroupResources, null, initialCurrentEvent.resourceData.oldId, ApiConst.getTooltipPersonalization, obj)
			.then((response) => {
				if (response?.value) {
					setCustomTooltipData(JSON.parse(response.value));
				}
			});
	}, [currentEvent]);

	const getGoodsInfo = useCallback(() => {
		const event = currentEvent?.data?.length > 0 ? currentEvent.data[0] : currentEvent;

		if (!event) return;
		const url = `${getPartialTrip}?&$filter=(id eq ${event.partialTripId})&$count=true&$expand=ptmovements($expand=movementGoods)`
		apiService
			.get(url)
			.then((response) => {
				if (response?.value && response.value.length > 0 ) {
					setPtMovementData(response.value[0]);
				}
			});
	}, [currentEvent]);


	useEffect(() => {
		if (currentEvent && !currentEvent.isRemark && !currentEvent.isAgendaItem && !currentEvent.isoutOfTimeEvent && currentEvent.resourceData?.oldId && currentEvent.tripNo) {
			getTooltipPersonalization();
			getGoodsInfo()
			tripStatusData.current = JSON.parse(dataService.getLocalStorageData('statusMetaData'))?.filter(s => s.type == 'Trip')
			startDateTime.current = `${moment(currentEvent?.ptStartingDate).format(process.env.REACT_APP_MOMENTDATEFORMAT)} ${currentEvent?.startTime || ''}`;
			endDateTime.current = `${moment(currentEvent?.ptEndingDate).format(process.env.REACT_APP_MOMENTDATEFORMAT)} ${currentEvent?.ptEndTime|| ''}`;

			// Parse the datetime strings into moment objects
			const start = moment(startDateTime.current, process.env.REACT_APP_MOMENTDATEFORMAT+' HH:mm:ss');
            const end = moment(endDateTime.current, process.env.REACT_APP_MOMENTDATEFORMAT+' HH:mm:ss');

            // Calculate the duration in hours
            if (start.isValid() && end.isValid()) {
                // Calculate the duration in hours				
                const duration = moment.duration(end.diff(start));

                // Format the duration into HH:mm:ss
                const days = Math.floor(duration.asDays());
                const hours = String(Math.floor(duration.asHours()) % 24).padStart(2, '0');
                const minutes = String(duration.minutes()).padStart(2, '0');
                const seconds = String(duration.seconds()).padStart(2, '0');

                // Format the duration based on the days value
                if (days > 0) {
                    tripDuration.current = `${days}d ${hours}h ${minutes}m ${seconds}s`;
                } else {
                    tripDuration.current = `${hours}:${minutes}:${seconds}`;
                }
            }
		}
	}, [currentEvent, getTooltipPersonalization]);

	const getTripStatus = useCallback((code)=>{
		return tripStatusData.current?.find(e => e.code == code)?.description
	}, [currentEvent]);
	const handleDragStart = (event, dragType) => {
		setTimeout(() => {
			const obj = {
				source: '',
				destination: '',
				eventType: '',
				isTripGenerated: false,
				items: { message: dragType + " dropped successfully!" }
			}
			dispatch(drageItemsReducer(obj))
		}, 0);
	};

	if (currentEvent?.popupType == "TruckHover") {
		return (
			<>
				<Typography variant="body2" color='secondary.contrastText' sx={{ backgroundColor: 'primary.main', fontSize: 18, p: .8, display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '3px', border: '1px rgb(200 200 200) solid', borderRadius: '3px' }} >
					<span>
						{currentEvent?.resourceData?.resourceNo?.toUpperCase()}
					</span>

					<span className={'number-plate ' + (currentEvent?.resourceData?.countryCode?.toLowerCase() || 'nl')}>
						{currentEvent?.resourceData?.vehicles[0]?.numberplate || ''}
					</span>
				</Typography>
				{/* <Advertising /> */}
			</>
		)
	} else if (currentEvent?.popupType == "TrailerHover") {
		return (<div>
			<Typography variant="body2" color='secondary.contrastText' sx={{ backgroundColor: 'primary.main', fontSize: 18, p: .8, display: 'flex', alignItems: 'center', marginBottom: '3px', border: '1px rgb(200 200 200) solid', borderRadius: '3px' }} >
				{currentEvent.resourceData.name}
			</Typography>
			<div className='qualifications-block'>
				<OpenRoof />
				<RoalerBed />
				<TailLift />
				<TemperatureHigh />
				{/* <TemperatureLow /> */}
				{/* <TrailerAcxle /> */}
				<MountedForklift />
			</div>
		</div>)
	} else if (currentEvent?.popupType == "LicenseHover") {
		return (<>
			<div className='track-trace'>
				<div className='track-map'>
					<div>
						{currentEvent.resourceData.id[0] == "v" && <BoxedTruck12Ton2Axles height="40" />}
						{currentEvent.resourceData.id[0] == "s" && <EuropeanTruck height="40" />}
						{currentEvent.resourceData.id[0] == "t" && <FlatbedTruck height="40" />}
						<div className='track-view'>
							<ul className='list-group vertical-steps'>
								<li class="list-group-item  completed "  >
									<div class="circles">
										<div class="circle1"></div>
										<div class="circle2 "></div>
										<div class="circle3 "></div>
									</div>
									<div class=""><div class=""><p class="">08:07  <span class="">Amsterdam (NLAMS)</span></p><h5 class="titleHD ">Booked</h5></div></div>
								</li>
								<li class="list-group-item  completed "  >
									<div class="circles">
										<div class="circle1"></div>
										<div class="circle2 "></div>
										<div class="circle3 "></div>
									</div>
									<div class=""><div class=""><p class="">09:10  <span class="">Amsterdam (NLAMS)</span></p><h5 class="titleHD ">REACHED AT WAREHOUSE</h5></div></div>
								</li>
								<li class="list-group-item  active "  >
									<div class="circles">
										<div class="circle1"></div>
										<div class="circle2 "></div>
										<div class="circle3 "></div>
									</div>
									<div class=""><div class=""><p class="">09:15  <span class="">Amsterdam (NLAMS)</span></p><h5 class="titleHD ">CARGO RECEIVED</h5></div></div>
								</li>
								<li class="list-group-item   "  >
									<div class="circles">
										<div class="circle1"></div>
										<div class="circle2 "></div>
										<div class="circle3 "></div>
									</div>
									<div class=""><div class=""><p class="">09:30  <span class="">Amsterdam (NLAMS)</span></p><h5 class="titleHD ">PICKED FROM WAREHOUSE</h5></div></div>
								</li>
								<li class="list-group-item   "  >
									<div class="circles">
										<div class="circle1"></div>
										<div class="circle2 "></div>
										<div class="circle3 "></div>
									</div>
									<div class=""><div class=""><p class="">09:35  <span class="">Amsterdam (NLAMS)</span></p><h5 class="titleHD ">DEPARTED FROM WAREHOUSE</h5></div></div>
								</li>
							</ul>

						</div>

					</div>
					<div className='map-cnt'>
						<img src={mapimg} style={{ width: '100%', verticalAlign: 'middle', }} alt="Map" />
					</div>
				</div>
			</div>
		</>)
	} else {
		if (currentEvent?.isRemark || currentEvent?.isAgendaItem) {
			return (<Typography variant="body2" color='primary' sx={{ fontSize: 18, p: .8, display: 'flex', alignItems: 'center', marginBottom: '3px', border: '1px rgb(200 200 200) solid', borderRadius: '3px' }} >
				{currentEvent?.description}
			</Typography>)
		} else if (currentEvent?.isoutOfTimeEvent) {
			return (<Typography variant="body2" color='primary' sx={{ fontSize: 18, p: .8, display: 'flex', alignItems: 'center', marginBottom: '3px', border: '1px rgb(200 200 200) solid', borderRadius: '3px' }} >
				Trip Continues
			</Typography>)
		}
		else if(currentEvent?.isRouteAction){
			return (
				<>
					{/* New UI ---------*/}
					<Box sx={{ p: .5, }}>
						<Grid container spacing={0} sx={{ border: 1, mb: .5, borderRadius: '5px', borderColor: '#BAB8B8', }}>
							<Grid item xs={12} sx={{ backgroundColor: 'primary.main', borderRadius: '5px', p: .5, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
								<Typography variant="body2" sx={{ fontSize: 15, display: 'flex', alignItems: 'center', color: 'secondary.contrastText', textShadow: '1px 1px 2px #000' }}  >
									<ControlCameraIcon sx={{ marginRight: 1 }} /> TRIP INFO
								</Typography>
								<Box sx={{ p: 0, display: 'flex', flexFlow: 'row' }} spacing={1}>
									{/* <Typography variant="body1" sx={{ fontSize: 12, display: 'flex', lineHeight: 1.2, alignItems: 'center', color: 'secondary.contrastText', marginRight: 1, }}  >
										Status
									</Typography> */}
									<Chip
										label={getTripStatus(currentEvent?.ptStatus)}
										size="small"
										className='ctm-chip'
										color='plan'
										sx={{ borderRadius: '4px' }}
										icon={<FiberManualRecordIcon sx={{ fontSize: 10, marginLeft: .5, width: 8, height: 8 }} />}
									/>
								</Box>
								<Box sx={{ p: 0, display: 'flex', flexFlow: 'column' }}>
									<Typography variant="body2" sx={{ fontSize: 12, display: 'flex', justifyContent: 'flex-end', lineHeight: 1.2, alignItems: 'center', color: '#ccd7ea', textAlign: 'right' }}  >
										Trip No./Partial Trip No.
									</Typography>
									<Typography variant="body1" sx={{ fontSize: 12, display: 'flex', justifyContent: 'flex-end', lineHeight: 1.2, alignItems: 'center', color: 'secondary.contrastText', textAlign: 'right' }}  >
									{[currentEvent?.tripNo, ptMovementData?.partialTrip]
									.filter(Boolean)
									.join('-')}
									</Typography>
								</Box>
							</Grid>
							<Grid item xs={12} sx={{ backgroundColor: 'secondary.contrastText', p: 1, borderRadius: '5px', display: 'flex', flexDirection: 'column' }}>

								<Paper
									sx={{
										display: 'flex',
										justifyContent: 'space-between',
										listStyle: 'none',
										backgroundColor: 'transparent',
										boxShadow: 'none',
										p: 0,
										paddingBottom: .5,
										borderBottom: 2,
										borderRadius: 0,
										borderColor: 'primary.main',
										m: 0,
										width: '100%',
									}}
									component="ul"
								>
									<ListItem>
										<Typography variant="body1" sx={{ fontSize: 12, display: 'flex', lineHeight: 1.2, alignItems: 'center', color: 'primary.main', textTransform: 'uppercase', fontWeight: 'bold' }}  >
											Begin
										</Typography>
										<Typography variant="body1" sx={{ fontSize: 12, display: 'flex', lineHeight: 1.2, alignItems: 'center', fontWeight: 'bold' }}  >
											{startDateTime.current}
										</Typography>
										<FiberManualRecordIcon color='primary' className='track-dot lft' sx={{ fontSize: 10, marginLeft: .5, width: 13, height: 13 }} />
									</ListItem>
									<ListItem>
										<Typography variant="body1" sx={{ fontSize: 12, display: 'flex', justifyContent: 'center', lineHeight: 1.2, alignItems: 'center', color: 'primary.main', textTransform: 'uppercase', fontWeight: 'bold' }}  >
											Duration
										</Typography>
										<Typography variant="body1" sx={{ fontSize: 12, display: 'flex', justifyContent: 'center', lineHeight: 1.2, alignItems: 'center', fontWeight: 'bold' }}  >
											{tripDuration.current}
										</Typography>
										<FiberManualRecordIcon color='primary' className='track-dot ctr' sx={{ fontSize: 10, marginLeft: .5, width: 13, height: 13 }} />
									</ListItem>
									<ListItem  >
										<Typography variant="body1" sx={{ fontSize: 12, display: 'flex', justifyContent: 'flex-end', lineHeight: 1.2, alignItems: 'center', color: 'primary.main', textTransform: 'uppercase', fontWeight: 'bold' }}  >
											End
										</Typography>
										<Typography variant="body1" sx={{ fontSize: 12, display: 'flex', justifyContent: 'flex-end', lineHeight: 1.2, alignItems: 'center', fontWeight: 'bold' }}  >
											{endDateTime.current}
										</Typography>
										<FiberManualRecordIcon color='primary' className='track-dot rit' sx={{ fontSize: 10, marginLeft: .5, width: 13, height: 13 }} />
									</ListItem>
								</Paper>
								{/* ====== */}

								<Grid container spacing={0} sx={{ borderRadius: '5px', borderColor: '#BAB8B8', mt: 2 }}>
									<Grid item xs={6} sx={{ backgroundColor: 'secondary.contrastText', p: 0, borderRadius: '5px', display: 'flex', }}>
										<div className='profile-block'>
											<Typography variant="body1" sx={{ fontSize: 12, marginBottom: '5px', fontWeight: 'bold', display: 'flex', lineHeight: 1.2, alignItems: 'center', color: 'primary.main', textAlign: 'right' }}  >
												Linked Resources On The Trip
											</Typography>
											<div className='profile-img'>
												<div className='imgs'>
													<img src={currentEvent?.driverImg ? currentEvent?.driverImg : dummyDriver} style={{ height: "60px", borderRadius: '4px', width: "60px", verticalAlign: 'middle', }} alt="driverImg" />
												</div>
												<Box sx={{ p: 0, display: 'flex', flexFlow: 'column', }}>
													<Typography variant="body2" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', marginBottom: '5px', lineHeight: 1.2, alignItems: 'center', color: 'primary.main' }}  >
														{`${currentEvent?.driverFirstName} ${currentEvent?.driverLastName}`}
													</Typography>
													<Box sx={{ p: 0, display: 'flex', flexFlow: 'row',justifyContent:'space-between' }}>
														<Typography variant="body1" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', color: 'primary.main', lineHeight: 1.2, alignItems: 'center', }}  >
															Vehicle:
														</Typography>
														<Typography variant="body1" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', lineHeight: 1.2, alignItems: 'center', }}  >
														<span className={'number-plate ' + (currentEvent?.vehicleCountryRegion?.toLowerCase() || 'nl')}>
															{currentEvent?.vehicleNumberPlate ? currentEvent?.vehicleNumberPlate : ""}
														</span>
														</Typography>
													</Box>
													<Box sx={{ p: 0,mt:.5, display: 'flex', flexFlow: 'row',justifyContent:'space-between' }}>
														<Typography variant="body1" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', color: 'primary.main', lineHeight: 1.2, alignItems: 'center', }}  >
															Trailer:
														</Typography>
														<Typography variant="body1" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', lineHeight: 1.2, alignItems: 'center', }}  >
														<span className={'number-plate ' + (currentEvent?.trailerCountryRegion?.toLowerCase() || 'nl')}>
															{currentEvent?.trailerNumberPlate ? currentEvent?.trailerNumberPlate : ""}
														</span>
														</Typography>
													</Box>

												</Box>
											</div>
										</div>
									</Grid>
									<Grid item xs={6} sx={{ px: .5, borderRadius: '5px', display: 'flex', }}>
										<Grid container spacing={0} sx={{ borderRadius: '0', }}>
											<Grid item xs={6} sx={{ p: 0, display: 'flex', flexFlow: 'column', mb: .3 }} >
												<Typography variant="body2" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', lineHeight: 1.2, color: 'primary.main', }}  >
													KM's Of The Trip
												</Typography>
												<Typography variant="body1" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', lineHeight: 1.2, color: 'primary.dark', }}  >
													{currentEvent?.distance}
												</Typography>
											</Grid>
											<Grid item xs={6} sx={{ p: 0, display: 'flex', flexFlow: 'column', mb: .3 }} >
												<Typography variant="body2" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', lineHeight: 1.2, color: 'primary.main', }}  >
													Drive and Rest Times
												</Typography>
												<Typography variant="body1" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', lineHeight: 1.2, color: 'primary.dark', }}  >
													{currentEvent?.driveDurationHM} & {currentEvent?.restDurationHM}
												</Typography>
											</Grid>
											<Grid item xs={6} sx={{ p: 0, display: 'flex', flexFlow: 'column', mb: .3 }} >
												<Typography variant="body2" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', lineHeight: 1.2, color: 'primary.main', }}  >
													No. Of Stops
												</Typography>
												<Typography variant="body1" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', lineHeight: 1.2, color: 'primary.dark', }}  >
													{noOfAction}
												</Typography>
											</Grid>
											<Grid item xs={6} sx={{ p: 0, display: 'flex', flexFlow: 'column', mb: .3 }} >
												<Typography variant="body2" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', lineHeight: 1.2, color: 'primary.main', }}  >
													Department
												</Typography>
												<Typography variant="body1" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', lineHeight: 1.2, color: 'primary.dark', }}  >
												{currentEvent?.planDepartment}
												</Typography>
											</Grid>
											<Grid item xs={6} sx={{ p: 0, display: 'flex', flexFlow: 'column', mb: .3 }} >
												<Typography variant="body2" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', lineHeight: 1.2, color: 'primary.main', }}  >
													Loading Degrees LM
												</Typography>
												<Typography variant="body1" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', lineHeight: 1.2, color: 'primary.dark', }}  >
													{(currentEvent?.actionCode) && <div style={{ maxWidth: '100px', margin: '4px 0px 0px 5px', position: 'relative', textAlign: 'center' }}>
														<div className='truckimg'>
															<TruckProgressIcon className="trans-truck" />
															<div className='progress-block'>
																<div className='progress-text' style={{ width: (Math.max(Math.round((currentEvent.lLForLoadingdegree || 0) / 100), 0)) + '%' }}>
																	{Math.max(Math.round((currentEvent.lLForLoadingdegree || 0) / 100), 0)}%
																</div>
															</div>
														</div>
													</div>}
												</Typography>
											</Grid>

										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
						<Grid container spacing={0} sx={{ border: 1, mb: .5, borderRadius: '5px', borderColor: '#BAB8B8', }}>
							<Grid item xs={12} sx={{ backgroundColor: 'primary.main', borderRadius: '5px', p: .5, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
								<Typography variant="body2" sx={{ fontSize: 15, display: 'flex', alignItems: 'center', color: 'secondary.contrastText', textShadow: '1px 1px 2px #000' }}  >
									<span style={{ marginRight: '5px' }}><IcoRoute /></span>
									ROUTE INFO
								</Typography>
								<Box sx={{ p: 0, display: 'flex', flexFlow: 'row' }} spacing={1}>
									{/* <Typography variant="body1" sx={{ fontSize: 12, display: 'flex', lineHeight: 1.2, alignItems: 'center', color: 'secondary.contrastText', marginRight: 1, }}  >
										Status
									</Typography> */}
									<Chip
										label={getTripStatus(currentEvent?.status)}
										size="small"
										className='ctm-chip'
										color='plan'
										sx={{ borderRadius: '4px' }}
										icon={<FiberManualRecordIcon sx={{ fontSize: 10, marginLeft: .5, width: 8, height: 8 }} />}
									/>
								</Box>
								<Box sx={{ p: 0, display: 'flex', flexFlow: 'row' }}>
									<div className='d-flex align-items-center'>
										<div style={{ fontWeight: '500', paddingRight: '8px', color: '#74e28c' }}>{currentEvent?.actionCode}</div>
										{service.getActionIcon(currentEvent?.actionCode,'#fff')}
									</div>
								</Box>
							</Grid>
							<Grid item xs={12} sx={{ backgroundColor: 'secondary.contrastText', p: 1, borderRadius: '5px', display: 'flex', flexDirection: 'column' }}>


								<Grid container spacing={0} sx={{ borderRadius: '5px', borderColor: '#BAB8B8' }}>
									<Grid item xs={5} sx={{ backgroundColor: 'secondary.contrastText', p: 0, borderRadius: '5px', display: 'flex', }}>

										<div className='address-block d-flex'>


											<FmdGoodIcon color='primary' />

											<Box sx={{ p: 0, display: 'flex', flexFlow: 'column', }}>
												<Typography variant="body1" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', lineHeight: 1.2, color: 'primary.dark', }}  >
												{[
													currentEvent?.city,
													currentEvent?.addresscode,
													currentEvent?.addressname,
													currentEvent?.address,
													currentEvent?.postCode
												]
													.filter(Boolean)
													.map((item, index, array) => (
														<>
															{item}
															{index < array.length - 1 && ','}
															<br />
														</>
													))}
												</Typography>

											</Box>
										</div>

									</Grid>
									<Grid item xs={7} sx={{ px: .5, borderRadius: '5px', display: 'flex', }}>
										<Grid container spacing={0} sx={{ borderRadius: '0', }}>
											<Grid item xs={6} sx={{ p: 0, display: 'flex', flexFlow: 'column', mb: .3 }} >
												<Typography variant="body2" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', lineHeight: 1.2, color: 'primary.main', textAlign: 'right' }}  >
													No. Of Movements
												</Typography>
												<Typography variant="body1" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', lineHeight: 1.2, color: 'primary.dark', textAlign: 'right' }}  >
													{ptMovementData?.ptmovements?.length | 0}
												</Typography>
											</Grid>
											<Grid item xs={6} sx={{ p: 0, display: 'flex', flexFlow: 'column', mb: .3 }} >
												<Typography variant="body2" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', lineHeight: 1.2, color: 'primary.main', textAlign: 'right' }}  >
													Route Sequence
												</Typography>
												<Typography variant="body1" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', lineHeight: 1.2, color: 'primary.dark', textAlign: 'right' }}  >
													{currentEvent.sequenceNo}
												</Typography>
											</Grid>
											<Grid item xs={6} sx={{ p: 0, display: 'flex', flexFlow: 'column', mb: .3 }} >
												<Typography variant="body2" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', lineHeight: 1.2, color: 'primary.main', textAlign: 'right' }}  >
													Planned (ETA)
												</Typography>
												<Typography variant="body1" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', lineHeight: 1.2, color: 'primary.dark', textAlign: 'right' }}  >
												{moment(currentEvent?.startingDate).format(process.env.REACT_APP_MOMENTDATEFORMAT) } {currentEvent?.startingTime}
												</Typography>
											</Grid>
											<Grid item xs={6} sx={{ p: 0, display: 'flex', flexFlow: 'column', mb: .3 }} >
												<Typography variant="body2" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', lineHeight: 1.2, color: 'primary.main', textAlign: 'right' }}  >
													Planned Duration
												</Typography>
												<Typography variant="body1" sx={{ fontSize: 12, display: 'flex', fontWeight: 'bold', lineHeight: 1.2, color: 'primary.dark', textAlign: 'right' }}  >
													{currentEvent?.durationHM}
												</Typography>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>

						<Grid container spacing={0} sx={{ border: 1, mb: 0, borderRadius: '5px', borderColor: '#BAB8B8',}}>
							<Grid item xs={12} sx={{ backgroundColor: 'primary.main', borderRadius: '5px',p: .5, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
								<Typography variant="body2" sx={{ fontSize: 15, display: 'flex', alignItems: 'center', color: 'secondary.contrastText', textShadow: '1px 1px 2px #000' }}  >
									<span style={{ marginRight: '5px' }}><ContainerIconWh /></span>
									ACTION/GOODS/CONTAINER INFO
								</Typography>
								<Box sx={{ p: 0, display: 'flex', flexFlow: 'row' }}>
									<Typography variant="body2" sx={{ fontSize: 12, display: 'flex', justifyContent: 'flex-end', lineHeight: 1.2, alignItems: 'center', color: '#ccd7ea', textAlign: 'right' }}  >
										No Of Movements :
									</Typography>
									<Typography variant="body1" sx={{ fontSize: 16, display: 'flex', marginLeft: 1, justifyContent: 'flex-end', lineHeight: 1.2, alignItems: 'center', color: '#74E28C', textAlign: 'right' }}  >
										{ptMovementData?.ptmovements?.length | 0}
									</Typography>
								</Box>

							</Grid>
							<Grid item xs={12} sx={{ backgroundColor: 'secondary.contrastText', p: 1, borderRadius: '5px', display: 'flex', flexDirection: 'column',height:'120px'}}>

								<div className='small-accordian'>
									{
										ptMovementData?.ptmovements?.map((movement,i)=>{
											return (
												<Accordion>
													<AccordionSummary
														expandIcon={<ExpandMoreIcon />}
														aria-controls="panel3-content"
														id="panel3-header"
													>
														<Typography sx={{ width: '100%', color: 'primary.main', fontWeight: 'bold', flexShrink: 0 }}>
														{[
															movement.fileNo,
															movement.shipmentNo,
															i + 1,
															movement.customerName,
															movement.startReference,
															movement.endReference,
															movement.shipmentReference,
															movement.fileReference,
															moment(`${movement.startDate} ${movement.startTimeTill}`).format(process.env.REACT_APP_MOMENTDATETIMEFORMAT)
														]
														.filter(Boolean)
														.join(' - ')}
														</Typography>
														{/* <Typography sx={{ color: 'primary.main', fontWeight: 'bold', }}>17-07-24  08:00-12:00</Typography> */}
													</AccordionSummary>
													<AccordionDetails sx={{ fontSize: '12px' }}>
														{movement.movementGoods.map(goods=>
															<span>
															{[
																goods.quantity,
																goods.uom,
																goods.description,
																goods.volume,
																goods.loadingLength,
																goods.adrUnNo,
																goods.adrTunnelCode,
																goods.adrClassCode,
															]
															.filter(Boolean)
															.join(' / ')}
																</span>																
															)}
													</AccordionDetails>
												</Accordion>
											)
										})
									}									
									{/* <Accordion defaultExpanded>
										<AccordionSummary
											expandIcon={<ExpandMoreIcon />}
											aria-controls="panel1-content"
											id="panel1-header"
										>
											<Typography sx={{ width: '70%', color: 'primary.main', fontWeight: 'bold', flexShrink: 0 }}>
												FTL17-1644 - 19686 - 1 - TESTCUSTA
											</Typography>
											<Typography sx={{ color: 'primary.main', fontWeight: 'bold', }}>17-07-24  08:00-12:00</Typography>
										</AccordionSummary>
										<AccordionDetails sx={{ fontSize: '12px' }}>
											<span>500 / spanCS / Test Container / 1500 / 0 / 0 /Danger
											Identification:  C / Danger Label 1: 1.5</span>
										</AccordionDetails>
									</Accordion>																									
									<Accordion>
										<AccordionSummary
											expandIcon={<ExpandMoreIcon />}
											aria-controls="panel3-content"
											id="panel3-header"
										>
											<Typography sx={{ width: '70%', color: 'primary.main', fontWeight: 'bold', flexShrink: 0 }}>
												FTL17-1644 - 19686 - 1 - TESTCUSTA
											</Typography>
											<Typography sx={{ color: 'primary.main', fontWeight: 'bold', }}>17-07-24  08:00-12:00</Typography>
										</AccordionSummary>
										<AccordionDetails sx={{ fontSize: '12px' }}>
											<span>500 / PCS / Test Container / 1500 / 0 / 0 /Danger
											Identification:  C / Danger Label 1: 1.5</span><br />
											<span>500 / PCS / Test Container / 1500 / 0 / 0 /Danger
											Identification:  C / Danger Label 1: 1.5</span>
										</AccordionDetails>
									</Accordion> */}
								</div>

							</Grid>
						</Grid>
					</Box>

					{/* OLD ========= */}
					<Box sx={{ p: 1,display: 'none' }} >
						<Typography variant="body2" color='primary' sx={{ fontSize: 18, p: .8, display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '3px', border: '1px rgb(200 200 200) solid', borderRadius: '3px' }}
							draggable onDragStart={e => handleDragStart(e, "Event")}>

							<div className='d-flex align-items-center'>
								<OpenWithIcon color='primary' sx={{ marginRight: .5 }} />
								{currentEvent?.tripNo}
								<span className='font12  d-flex align-items-center' style={{ fontWeight: '600', marginLeft: '15px', color: '#515151' }}>
									<AccessTimeIcon sx={{ marginRight: '5px', fontSize: 15 }} /> <span>{moment(currentEvent?.start).format('h:mm A')} - {moment(currentEvent?.end).format('h:mm A')}</span>
								</span>
							</div>
							{(currentEvent?.actionCode) && <div style={{ maxWidth: '100px', margin: '4px 0px 0px 5px', position: 'relative', textAlign: 'center' }}>
								<div className='truckimg'>
									<TruckProgressIcon />
									<div className='progress-block'>
										<div className='progress-text' style={{ width: (Math.max(Math.round((currentEvent.lLForLoadingdegree || 0) / 100), 0)) + '%' }}>
											{Math.max(Math.round((currentEvent.lLForLoadingdegree || 0) / 100), 0)}%
										</div>
									</div>
								</div>
							</div>}
						</Typography>

						<div style={{ padding: '5px 0 0 0', overflow: 'hidden', display: 'flex', alignItems: 'center' }}>
							<div className='w-100'>
								<div className="md-custom-event-details" style={{ display: 'flex', alignItems: 'center', marginBottom: 10, justifyContent: 'space-between' }}>
									{/* <img src={faTruck} style={{ height: "15px", width: "15px", verticalAlign: 'middle', marginRight: '5px' }} alt="vehicle" /> */}
									{/* <div style={{ fontWeight: 'bold', }}>{currentEvent?.tripNo}</div> */}
									<div className='d-flex align-items-center'>
										{service.getActionIcon(currentEvent?.actionCode)}

										<div style={{ fontWeight: 'bold', paddingLeft: '8px', color: 'green' }}>{currentEvent?.actionCode}</div>
									</div>
								</div>

								<div className="font12 d-flex" style={{ fontWeight: 'bold', paddingRight: '8px', }}>
									<LocationOnIcon color='primary' />
									<div style={{ paddingLeft: '8px' }}>
										{[
											currentEvent?.city,
											currentEvent?.addresscode,
											currentEvent?.addressname,
											currentEvent?.address
										]
											.filter(Boolean)
											.map((item) => (
												<>
													{item},
													<br />
												</>
											))}
										{currentEvent?.postCode}
									</div>
								</div>
							</div>

							{iconActive == Consts.DRIVERS && (
								<>
									<div className='d-flex flex-row'>
										<div className='d-flex cursor-pointer relative'>
											{
												currentEvent?.truckType ? (
													<>
														{currentEvent?.truckType[0] == "v" && <BoxedTruck12Ton2Axles />}
														{currentEvent?.truckType[0] == "s" && <EuropeanTruck />}
														{currentEvent?.truckType[0] == "t" && <FlatbedTruck />}
													</>
												) : "No Trucktype"
											}
										</div>
										<span className={'number-plate mt10 ' + (currentEvent?.country?.toLowerCase() || 'nl')}>
											{currentEvent?.vehicleNumberPlate ? currentEvent?.vehicleNumberPlate : "No VehiclePlate"}
										</span>
									</div>
									<div className='d-flex flex-row ml-10'>
										<div className='d-flex cursor-pointer relative'>
											{
												currentEvent?.trailerType ? (
													<>
														{currentEvent?.trailerType[0] == "v" && <BoxTrailer height="30" width="70" />}
														{currentEvent?.trailerType[0] == "s" && <TankTrailer height="35" width="70" />}
														{currentEvent?.trailerType[0] == "t" && <ChassisTrailer height="35" width="70" />}
													</>
												) : "No Trailertype"
											}
										</div>
										<span className={'number-plate mt10 ' + (currentEvent?.country?.toLowerCase() || 'nl')}>
											{currentEvent?.trailerNumberPlate ? currentEvent?.trailerNumberPlate : "No TrailerpPlate"}
										</span>
									</div>
								</>
							)}
							{iconActive == Consts.VEHICLES && (
								<>
									<div className='d-flex flex-row ml-10'>
										<div className='d-flex cursor-pointer relative'>
											{
												currentEvent?.trailerType ? (
													<>
														{currentEvent?.trailerType[0] == "v" && <BoxTrailer height="35" width="70" />}
														{currentEvent?.trailerType[0] == "s" && <TankTrailer height="35" width="70" />}
														{currentEvent?.trailerType[0] == "t" && <ChassisTrailer height="35" width="70" />}
													</>
												) : "No TrailerType"
											}
										</div>
										<span className={'number-plate mt10 ' + (currentEvent?.country?.toLowerCase() || 'nl')}>
											{currentEvent?.trailerNumberPlate ? currentEvent?.trailerNumberPlate : "No TrailerpPlate"}
										</span>
									</div>
									<div className='d-flex flex-row ml-10' style={{ backgroundColor: '#f1f1f1', borderRadius: '5px', padding: '5px', overflow: 'hidden', width: '150px' }}>
										<div style={{ padding: '0', borderRadius: '5px', textAlign: 'center' }}>
											<img src={currentEvent?.driverImg ? currentEvent?.driverImg : dummyDriver} style={{ height: "60px", borderRadius: '4px', width: "60px", verticalAlign: 'middle', }} alt="driverImg" />
										</div>
										<span className='mt10 font12' style={{ fontWeight: 'bold', whiteSpace: 'nowrap', textWrap: 'balance', Width: '100px', textOverflow: 'ellipsis', display: 'block' }}>
											{`${currentEvent?.driverFirstName} ${currentEvent?.driverLastName}`}
										</span>
									</div>
								</>
							)}
							{(iconActive == Consts.TRAILERS || iconActive == Consts.CHASSIS || iconActive == Consts.VARIOUS) && (
								<>
									<div className='d-flex flex-row'>
										<div className='d-flex cursor-pointer relative'>
											{
												currentEvent?.truckType ? (
													<>
														{currentEvent?.truckType[0] == "v" && <BoxedTruck12Ton2Axles />}
														{currentEvent?.truckType[0] == "s" && <EuropeanTruck />}
														{currentEvent?.truckType[0] == "t" && <FlatbedTruck />}
													</>
												) : "No TruckType"
											}
										</div>
										<span className={'number-plate mt10 ' + (currentEvent?.country?.toLowerCase() || 'nl')}>
											{currentEvent?.vehicleNumberPlate ? currentEvent?.vehicleNumberPlate : "No VehiclePlate"}
										</span>
									</div>
									<div className='d-flex flex-row ml-10' style={{ backgroundColor: '#f1f1f1', borderRadius: '5px', padding: '5px', overflow: 'hidden', width: '150px' }}>
										<div style={{ padding: '0', borderRadius: '5px', textAlign: 'center' }}>
											{currentEvent?.driverFirstName && <img src={currentEvent?.driverImg ? currentEvent?.driverImg : dummyDriver} style={{ height: "60px", borderRadius: '4px', width: "60px", verticalAlign: 'middle', }} alt="user" />}
										</div>
										<span className='mt10 font12' style={{ fontWeight: 'bold', whiteSpace: 'nowrap', textWrap: 'balance', Width: '100px', textOverflow: 'ellipsis', display: 'block' }}>
											{`${currentEvent?.driverFirstName} ${currentEvent?.driverLastName}`}
										</span>
									</div>
								</>
							)}

							{!currentEvent?.startAction && (
								<div className='track ' style={{ width: '100%', maxWidth: '700px', margin: '0px 0px 0px 10px', position: 'relative', textAlign: 'center', display: 'none' }}>
									{currentEvent?.actions?.map(a => (
										<div className='truckitem '>
											{service.getActionIcon(a.action)}
											<div>
												<span className='place'>{a.shortCity}</span> <span className='time-text'>{a.time}</span>
											</div>
										</div>
									))}
								</div>
							)}
						</div>

						<div className='bg-msg'>
							"Arriving soon to the location"
							<div className='date-time'>
								<AccessTimeIcon /> 11:00 PM
							</div>
						</div>
						<div className='d-flex' style={{ flexWrap: 'wrap', minHeight: '150px', maxHeight: '150px', marginTop: '4px' }}>
							{
								customTooltipData?.map((e) => <>
									<div style={{ fontWeight: '500', fontSize: '12px', width: '100%', marginBottom: '2px', alignItems: 'flex-start' }} className='d-flex'> <ArrowRightIcon color='primary' />  {e.V}</div>
								</>)
							}
						</div>
					</Box>
				</>
			)
		}
	}
}
export default CustomAgendaTooltip